import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link, useHistory } from 'react-router-dom';

import { useForm, Controller } from 'react-hook-form';

// components
import Container from '@material-ui/core/Container';
import CodeInput from 'components/shared/CodeInput';
import Grid from '@material-ui/core/Grid';
import LoadingButton from 'components/shared/LoadingButton';
import Typography from 'components/shared/Typography';
import Input from 'components/shared/Input';
import Lottie from 'react-lottie';

// assets
import monkey from 'assets/images/monkey.png';
import monkeyActive from 'assets/images/monkeyActive.png';
import leftImage from 'assets/images/customer-login.png';
import requestOTPImage from 'assets/images/customer/requestOTP.png';
import submitOTPImage from 'assets/images/customer/submitOTP.png';

import otpAnimation from 'assets/lotties/otp.json';

// constants
import { SPACING, SPACING_THIRD } from 'constants/spacing';

import { MOBILE_REGEX } from 'constants/regex';

//utils
import { digitsFaToEn } from 'persian-tools2';
import { useRequestOTP, useSubmitOTP } from 'hooks/auth';

//libs
import { getRefreshTokenCookie, removeOTPTokenCookie, setRefreshTokenCookie, setSignupTokenCookie } from 'lib/Storage';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    // minHeight: '100vh',
    minHeight:"fit-content",
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  leftPanel: {
    
    width: '100%',
    // minHeight: '100vh',
    minHeight:"fit-content",
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  form: {
    width: '100%',
  },
  buttonWraper: {
    marginTop: theme.spacing(SPACING),
  },
  monkey: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  phoneInput: {
    '& .MuiInputBase-input::placeholder': {
      textAlign: 'center',
    },
    '& .MuiInputBase-input': {
      textAlign: 'right',
      direction: 'rtl',
    },
  },
  largeLabel: {
    marginTop: 35,
    fontSize: theme.typography.pxToRem(25),
    height:"75%",
    '&:disabled':{
      color: '#959595'
    }
    
  },
  wholepage:{
    width:"100vw",
    height:"100vh",
    backgroundColor:"#e5e5e5",
  },
  mainContainer:{
    backgroundColor:"#f5f5f5",
    // borderRadius:"10px",
    position:'relative',
    top:"15%",
    padding:"0px",

    [theme.breakpoints.down('xs')]: {
      backgroundColor:"#e5e5e5",
     top:"0",
    },
  }
}));

/**
 * @component Otp
 */
function Otp() {
  const classes = useStyles();
  const history = useHistory();
  const [pinCode, setPinCode] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [step, setStep] = useState('enterPhone');

  const { mutate: mutateRequest, loading: isLoadingRequest } = useRequestOTP();
  const { mutate: mutateSubmit, loading: isLoadingSubmit } = useSubmitOTP();

  const onSubmitRequest = (e) => {
    // e.preventDefault();
    setPhoneNumber(e.phoneNumber)

    mutateRequest(e.phoneNumber, {
      onSuccess: (data) => {
        if (data?.status === 'OK') {
          setStep("enterOTP")
        }
      },
    });
    
    // history.push('/auth/complete-profile');
  };
  const onSubmitSubmit = (e) => {
    e.preventDefault();
    console.log(pinCode)

    mutateSubmit(pinCode , {
      onSuccess: (data) => {
        if (data?.status === 'OK') {
          removeOTPTokenCookie()
          setRefreshTokenCookie(data?.refreshToken)
          console.log(data)
          history.push("/customer/events")
        }
        else if (data?.status === 'OK,NEWUSER') {
          removeOTPTokenCookie()
          setSignupTokenCookie(data?.signupToken)
          console.log("NEWUSER,",data)
          history.push("/auth/signup")
        }
      },
    });
    
    // history.push('/auth/complete-profile');
  };

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      phoneNumber: '',
    },
  });

  const validateRegex = (value) => {
    const innerValue = digitsFaToEn(value);
    if (!MOBILE_REGEX.test(innerValue)) {
      return 'شماره موبایل نامعتبر است';
    }
    return true;
  };

  if (!!getRefreshTokenCookie()) history.push('/');

  return (
    <div className={classes.wholepage}>
    <Container maxWidth="md" className={classes.mainContainer}>
      <Grid container spacing={0}>
        {/* <div className={classes.root}> */}
        <Grid item xs={12} md={6} className={classes.root}>
          {step === 'enterPhone' && (
            <form noValidate onSubmit={handleSubmit(onSubmitRequest)} className={classes.form}>
              <Grid container spacing={SPACING_THIRD} style={{padding:"15%"}}>
                <Grid item xs={12}>
                  <Typography align="center" variant="h2">
                    به قاصدک خوش آمدید!
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  {/* <CodeInput fields="5" noWrap value={pinCode} onChange={setPinCode} /> */}
                  <Controller
                    name="phoneNumber"
                    rules={{ required: true, validate: validateRegex }}
                    control={control}
                    render={({ field }) => (
                      <Input
                        label="شماره تلفن"
                        type="tel"
                        fullWidth
                        InputLabelProps={{
                          shrink: true,
                        }}
                        placeholder="لطفا شماره موبایل خود را وارد کنید"
                        className={classes.phoneInput}
                        textAlign="center"
                        helperText={
                          errors?.phoneNumber && errors?.phoneNumber?.type === 'validate' ? (
                            <Typography
                              variant="body2"
                              component="span"
                              color="error"
                              locale="en"
                            >
                              {errors?.phoneNumber?.message}
                            </Typography>
                          ) : errors?.phoneNumber?.type === 'required' ? (
                            <Typography variant="body2" component="span" color="error">
                              وارد کردن این فیلد ضرروی است
                            </Typography>
                          ) : null
                        }
                        {...field}
                      />
                    )}
                  />
                  {/* <Input value={phoneNumber} onChange={setPhoneNumber} fullWidth label="لطفا شماره موبایل خود را وارد کنید" className={classes.phoneInput} /> */}
                </Grid>
                <Grid item xs={12} className={classes.buttonWraper}>
                  <LoadingButton
                    className={classes.largeLabel}
                    type="submit"
                    // size="small"
                    fullWidth
                    variant="contained"
                    color="primary"
                    disabled={errors?.phoneNumber}
                    loading={isLoadingRequest}
                    
                  >
                    دریافت کد
                  </LoadingButton>
                </Grid>
              </Grid>
            </form>
          )}
          {step === 'enterOTP' && (
            <form noValidate onSubmit={onSubmitSubmit} className={classes.form}>
              <Grid container spacing={SPACING_THIRD} style={{padding:"15%"}}>
                <Grid item xs={12} style={{marginBottom:"-15%"}}>
                  <Lottie
                    options={{
                      loop: true,
                      autoplay: true,
                      animationData: otpAnimation,
                      rendererSettings: {
                        preserveAspectRatio: 'xMidYMid slice',
                      },
                      // initialSegment: [11, 121],
                    }}
                    height={'70%'}
                    width={'80%'}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography align="center">
                    {`کد یکبار مصرف به شماره ${phoneNumber} ارسال شد`}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <CodeInput fields="5" noWrap value={pinCode} onChange={setPinCode} type="code" />
                </Grid>
                <Grid item xs={12} className={classes.buttonWraper}>
                  <div onClick={() => setStep("enterPhone")} style={{textAlign:"center", marginTop:"-10%"}}>
                    <Typography gutterBottom component={Link} to="#" color="primary" align="center">
                      ویرایش شماره
                    </Typography>
                  </div>
                  <LoadingButton
                    className={classes.largeLabel}
                    type="submit"
                    // size="small"
                    fullWidth
                    variant="contained"
                    color="primary"
                    disabled={errors?.phoneNumber}
                    loading={isLoadingSubmit}
                    
                  >
                  تایید
                  </LoadingButton>
                </Grid>
              </Grid>
            </form>
          )}
        </Grid>

        <Grid item xs={12} md={6} className={classes.leftPanel}>
          {/* <div className={classes.monkey}> */}
          {step === 'enterPhone' && <img src={requestOTPImage} alt="left" height={'80%'} />}
          {step === 'enterOTP' && <img src={submitOTPImage} alt="left" height={'80%'} />}

        </Grid>
        {/* </div> */}
      </Grid>
    </Container>
    </div>
  );
}

export default Otp;
